<!-- navBar -->
<template>
  <div class="navBar" :class="scrollTop>94?'op1':''">
    <div class="nav_box_center">
      <div class="nav_box">
        <img class="img" src="../../static/images/common/中文LOGO.png" @click="goIndex()"/>
        <div class="title_box">
          <div class="items" :class="navType==1?'active':''" @click="active(1)">首页</div>
          <div class="items" :class="navType==2?'active':''" @click="active(2)">熔炼设备</div>
          <div class="items" :class="navType==3?'active':''" @click="active(3)">悬浮冶金</div>
          <div class="items" :class="navType==4?'active':''" @click="active(4)">材料研制</div>
          <div class="items" :class="navType==5?'active':''" @click="active(5)">关于我们</div>
          <div class="items" :class="navType==8?'active':''" @click="active(8)">新闻资讯</div>
          <div class="items" :class="navType==6?'active':''" @click="active(6)">加入我们</div>
          <div class="items" :class="navType==7?'active':''" @click="active(7)">联系我们</div>
          <div class="items lageBox" @click="toEn()">EN</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'navBar',
    components: {},
    data() {
      return {

      }
    },
    computed: {
      //本地存储的 选中页面type
      navType() {
        return this.$store.state.navType;
      },
      //当前页面滚动距离
      scrollTop() {
        return this.$store.state.topHeight;
      },
    },
    watch: {
      $route(to,from){
        this.setFunc()
      },

      // 跳转
      navType(n, o) {
        if (n == 1) {
          this.$router.push({
            path: "/"
          }); // 跳转首页
        } else if (n == 2) {
          this.$router.push({
            path: "/smeltingEquipment"
            // path: "/programme?type=" + n
          }); // 熔炼设备
        } else if (n == 3) {
          this.$router.push({
            path: "/metallurgy"
          }); // 悬浮冶金
        } else if (n == 4) {
          this.$router.push({
            path: "/materialDev"
          }); // 材料研制
        } else if (n == 5) {
          this.$router.push({
            path: "/about"
          }); // 关于我们
        }
        else if (n == 6) {
          this.$router.push({
            path: "/joinUs"
          }); // 加入我们
        }
        else if (n == 7) {
          this.$router.push({
            path: "/contact"
          }); // 联系我们
        }
        else if (n == 8) {
          this.$router.push({
            path: "/news"
          }); // 新闻资讯
        }
      }
    },
    created() {
      //页面刷新时 根据页面路由判断选中的哪个导航
      this.setFunc()
    },
    mounted() {

    },
    methods: {
      toEn(){
        this.$router.push({
            path: "/en"
          });
      },
      setFunc(){
        let type = this.$route.path;
        if (type.indexOf("news") != -1) {
        this.$store.commit("saveNavType", 8);
      }else if (type.indexOf("contact") != -1) {
        this.$store.commit("saveNavType", 7);
      } else if (type.indexOf("joinUs") != -1) {
        this.$store.commit("saveNavType", 6);
      }else if (type.indexOf("about") != -1) {
        this.$store.commit("saveNavType", 5);
      } else if (type.indexOf("materialDev") != -1) {
        this.$store.commit("saveNavType", 4);
      } else if (type.indexOf("metallurgy") != -1) {
        this.$store.commit("saveNavType", 3);
      } else if (type.indexOf("smeltingEquipment") != -1) {
        this.$store.commit("saveNavType", 2);
      } else {
        this.$store.commit("saveNavType", 1);
      }
      },
      // 切换选中
      active(n) {
        this.$store.commit("saveNavType", n);
      },
      goIndex(){
        this.$router.push({
            path: "/"
          }); // 跳转首页
      }
    },
  }

</script>

<style lang='less' scoped>
  .navBar {
    position: fixed;
    z-index: 100;
    top: 0;
    width: 100%;
    min-width: 1200px;
    height: 94px;
    background-color: rgba(255, 255, 255, 0.8);
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;

    .nav_box_center {
      width: 1200px;
      height: 94px;
      opacity: 1;
      display: flex;
      margin: 0 auto;
      align-items: center;
      justify-content: space-between;

      .nav_box {
        width: 1200px;
        height: 94px;
        display: flex;
        margin: 0 auto;
        align-items: center;
        justify-content: space-between;

        .img {
          width: 293px;
          height: 67px;
          cursor: pointer;
        }

        .title_box {
          width: 820px;
          height: 60px;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #545454;
          display: flex;
          align-items: center;
          justify-content: right;
          position: relative;

          .items {
            margin: 0 16px;
            padding: 7px 3px;
            font-weight: 400;
            border-bottom: 3px solid transparent;
            cursor: pointer;
            
          }
          .items:last-child{
            padding-right: 0;
            margin-right: 0;
          }
          .items.active {
            border-bottom: 3px solid #c30000;
            color: #333333;
          }
          .items:hover{
            color: #333333;
          }
          .lageBox {
            border: none;
            width: 40px;
            height: 30px;
            background-color: #c30000;
            font-size: 14px;
            color: #fefefe;
            margin-left: 0;
            position: absolute;
            right: -45px;
            top: 15px;
            padding-left: 0;
          }
          .lageBox:hover{
            color: #fefefe;
          }
        }
      }
    }
  }

  .op1.navBar {
    background-color: rgba(255, 255, 255, 1);
  }

</style>



// WEBPACK FOOTER //
// src/components/navBarPage.vue